module.exports = __webpack_public_path__ + "static/media/PublicService.a617bcdb.svg";